module.exports = __webpack_public_path__ + "static/img/说明2-2-沙具调整.5d5b3be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mengceng/说明2-2-沙具调整.png
// module id = x1o7
// module chunks = 1